import React, { useState, useEffect } from 'react';
import Navbar from './components/dashboard/navbar/Navbar';
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Sidebar from './components/dashboard/sidebar/sidebar-ui/Sidebar'
import { useTranslation } from "react-i18next";
import PageLoader from './components/general/page-loader/PageLoader';
import PushNotification from './components/notification/PushNotification';
import useRout from './components/general/general-component/abstruct-component/Routes';

const App = () => {

  let langLocal = localStorage.getItem('pentalensLang');
  const mode = localStorage.getItem('mode-pentalens');
  const switchM = localStorage.getItem('switch');
  const [isLoading, setIsLoading] = useState(true);
  const [Switchh, setSwitchh] = useState(switchM);
  const [t, i18n] = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('pentalensLang'));
  }, []);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const openSidebar = () => {
    setSidebarOpen(true);
  }

  const closeSidebar = () => {
    setSidebarOpen(false);
  }

  const toggleSwitch = (stringg) => {
    console.log(stringg)
    localStorage.setItem('mode-pentalens', stringg);
    window.location.reload()
  }
  let token = localStorage.getItem("tokenA");
  const routes = useRout(token);

  return (
    <>
      <div>
        <header>
          <PushNotification />
        </header>
      </div>
      <BrowserRouter basename="/dashboard">
        <body className={mode === 'dark' ? "dark" : "light"}>
          {
            isLoading ? (
              <PageLoader setIsLoading={setIsLoading} isLoading={isLoading} />
            ) : (
              <div className={token !== null ? langLocal == "ar" ? "container_ar" : "container_en" : ""}>
                {
                  token != null && (
                    <>
                      <Navbar sidebarOpen={sidebarOpen} openSidebar={openSidebar} toggleSwitch={toggleSwitch} />
                      <Sidebar sidebarOpen={sidebarOpen} closeSidebar={closeSidebar} Switchh={Switchh} />
                    </>
                  )
                }
                <Routes>
                  {routes.map((route, index) => (
                    <Route key={index} exact path={route.path} element={route.element} />
                  ))}
                </Routes>

              </div>
            )
          }
        </body>
      </BrowserRouter>
    </>

  );
}

export default App;
